// Server and IP configuration for DrawingBoard
// Edit these values as needed for your environment

export const SERVER_IP = '86.157.76.90';   // (Angus) this needs to be replaced
// with router's PUBLIC IP 
export const SERVER_PORT = 3131;
export const SERVER_HTTP = `http://${SERVER_IP}:${SERVER_PORT}`;
export const SERVER_WS = `ws://${SERVER_IP}:${SERVER_PORT}/ws`; 